<div class="flex h-screen bg-white/95 dark:bg-gray-950 overflow-hidden">
  <app-sidemenu [isOpen]="isSidebarOpen()" (toggle)="toggleSidebar()"></app-sidemenu>
  <div class="flex flex-col flex-1 overflow-hidden transition-all duration-300">
    <app-header [isSidebarOpen]="isSidebarOpen()" (toggleSidebar)="toggleSidebar()"></app-header>
    <main class="flex-1 overflow-y-auto px-4 py-2">
      <router-outlet></router-outlet>
    </main>
    <!-- <app-footer></app-footer> -->
  </div>
</div>